import api from '@/api'
// get spend overview report data
export default {
  getOverviewReportData(filters) {
    return new Promise(function (resolve, reject) {
      const params = Object.keys(filters)
      .map(key => `${key}=${filters[key]}`)
      .join('&')
      api
        .request('get', `/api/v1/campaigns/spend/overview-report?limit=999&${params}`, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  },
  getCOGSPerCampaign(filters) {
    return new Promise(function (resolve, reject) {
      const params = Object.keys(filters)
      .map(key => `${key}=${filters[key]}`)
      .join('&')
      api
        .request('get', `/api/v1/campaigns/spend/cogsPerCampaign?limit=999&${params}`, true)
        .then(response => {
          if (response.status !== 200) {
            reject(response)
            return
          }
          resolve(response.data)
        })
        .catch(error => {
          // Request failed.
          reject(error)
        })
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/views/DashboardComponents/SpendHelper.js